<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card title="Logo Yükle">
          <pre-loading v-if="uploading" />
          <template v-else>
            <!-- Eğer logo mevcutsa resmi görüntülemek için b-img kullanıyoruz -->
            <b-img
              v-if="itemData.logo"
              :src="baseURL + '/media/dealers/' + itemData.logo"
              alt="Logo"
              fluid
              class="mb-3"
            />
            <b-form-file
              id="logo-file"
              v-model="logo"
              class="mt-1"
              placeholder="Bir dosya seçin veya buraya bırakın..."
              drop-placeholder="Dosyayı buraya bırakın..."
              browse-text="Dosya Seçin"
            />
            <div class="mt-1">
              <b-button
                variant="primary"
                :disabled="!logo"
                @click="uploadFile"
              >
                <FeatherIcon icon="UploadIcon" />
                Logo Yükle
              </b-button>
            </div>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BButton, BCard, BCol, BRow, BFormFile, BImg,
} from 'bootstrap-vue'
import PreLoading from '@/layouts/components/common/PreLoading.vue'

export default {
  name: 'LogoUploadCard',
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
    BFormFile,
    BImg,
    PreLoading,
  },
  data() {
    return {
      baseURL: this.$store.state.app.baseURL,
      logo: null,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['dealers/dataItem']
    },
    uploading() {
      return this.$store.getters['fileUpload/uploading']
    },
  },
  methods: {
    uploadFile() {
      const formData = new FormData()
      formData.append('file', this.logo)

      this.$store.dispatch('fileUpload/uploadFile', {
        upload_file: this.logo,
        folder: 'dealers',
      })
        .then(response => {
          this.itemData.logo = response.filename
        })
        .catch(error => {
          console.error('Dosya yükleme hatası:', error)
        })
    },
  },
}
</script>
